import $ from 'jquery';
import {
  prepareChessboard,
  showMagnus,
  loadNextConfiguration,
  showCapturedPieces,
  hideCapturedPieces
} from '../../utils';
import ChessBoard from '../../components/chessBoard';
import {
  BLACK_INITIAL_MOVE,
  WHITE_PIECE_SEARCH_KEY,
  BLACK_KING_SEARCH_KEY,
  WRONG_ANSWER_AUDIO,
  CORRECT_ANSWER_AUDIO
} from '../../utils/constants';

var tryCount = 0;

/**
* @name lesson7Assignment1
* @function
* @param {config}
* @description: activity related task
*/
export function lesson7Assignment1(config) {

  let callback = function () {
    let body = `
      <div class="card">
        <div class="card-wrapper">
          <ul class="options-table">
            <li class="table-row flex-vertical-center" index="0"><span class="answer-img"></span><span class="answer">1R + 4p = Q</span></li>
            <li class="table-row flex-vertical-center" index="1"><span class="answer-img"></span><span class="answer">2N + 1B = Q</span></li>
            <li class="table-row flex-vertical-center" index="2"><span class="answer-img"></span><span class="answer">1B + 1N + 3p = Q</span></li>
            <li class="table-row flex-vertical-center" index="3"><span class="answer-img"></span><span class="answer">1R + 1N + 3p = Q</span></li>
            <li class="table-row flex-vertical-center" index="4"><span class="answer-img"></span><span class="answer">2N + 3p = Q</span></li>
            <li class="table-row flex-vertical-center" index="5"><span class="answer-img"></span><span class="answer">1B+ 6p = Q</span></li>
            <li class="table-row flex-vertical-center" index="6"><span class="answer-img"></span><span class="answer">2B+ 1R = Q</span></li>
            <li class="table-row flex-vertical-center" index="7"><span class="answer-img"></span><span class="answer">9p = Q</span></li>
            <li class="table-row flex-vertical-center" index="8"><span class="answer-img"></span><span class="answer">2R = Q</span></li>
            <li class="table-row flex-vertical-center" index="9"><span class="answer-img"></span><span class="answer">3B = Q</span></li>
          </ul>
        </div>
      </div>`;

    $('.activity-section-content').html(body);

    $('.table-row').click(function () {
      let index = parseInt($(this).attr('index'), 10),
        correctCount;

      if (index === 3 || index === 6 || index === 8) {
        $(this).addClass('wrong')
        $(document).trigger('audio-play', WRONG_ANSWER_AUDIO)
      } else {
        $(this).addClass('correct')
        $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO)
      }

      correctCount = $('.table-row.correct').length

      if(correctCount === 7) {
        loadNextConfiguration(2000, config.next, true)
      }
    });
  }
  return callback;
}

/**
* @name lesson7Assignment3
* @function
* @param {config}
* @description: chess board related task
*/
export function lesson7Assignment3(config) {
  let next = config.next,
    initialBoardPosition = config.position,
    timeDelay = 2000;

  let afterLoad = function () {
    prepareChessboard(config);
    tryCount = 0
  }

  let onDragStart = function (source, piece, position, orientation) {
    if (piece.search(BLACK_KING_SEARCH_KEY) !== -1 || piece.search(WHITE_PIECE_SEARCH_KEY) !== -1) {
      return false;
    }
  }

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    let move = ChessBoard.game.move({
      from: source,
      to: target,
    });

    if (move === null) {
      return 'snapback';
    } else {
      if (!move.captured) {
        ChessBoard.game = new window.Chess(ChessBoard.board.fen() + BLACK_INITIAL_MOVE);
        return 'snapback';
      } else {
        showCapturedPieces(piece, move)
      }
    }
  }

  var onSnapEnd = function (source, target, piece) {
    let boardFen = ChessBoard.board.fen();

    if ($('.chessboard-63f37').find('.piece-417db').length === 2) {
      loadNextConfiguration(3500, next, true)
    } else if (
      (target === 'a3' && $('#chessBoard .square-a7').find('.piece-417db').length === 0 && $('#chessBoard .square-f8').find('.piece-417db').length === 0 && $('#chessBoard .square-g3').find('.piece-417db').length === 0) ||
      (target === 'a7' && $('#chessBoard .square-a3').find('.piece-417db').length === 0 && $('#chessBoard .square-b6').find('.piece-417db').length === 0 && $('#chessBoard .square-f2').find('.piece-417db').length === 0 && $('#chessBoard .square-h7').find('.piece-417db').length === 0 && $('#chessBoard .square-b8').find('.piece-417db').length === 0) ||
      (target === 'b1' && $('#chessBoard .square-b6').find('.piece-417db').length === 0 && $('#chessBoard .square-b8').find('.piece-417db').length === 0 && $('#chessBoard .square-h7').find('.piece-417db').length === 0) ||
      (target === 'b6' && $('#chessBoard .square-a7').find('.piece-417db').length === 0 && $('#chessBoard .square-b8').find('.piece-417db').length === 0 && $('#chessBoard .square-d8').find('.piece-417db').length === 0 && $('#chessBoard .square-f2').find('.piece-417db').length === 0 && $('#chessBoard .square-b1').find('.piece-417db').length === 0) ||
      (target === 'b8' && $('#chessBoard .square-a7').find('.piece-417db').length === 0 && $('#chessBoard .square-b1').find('.piece-417db').length === 0 && $('#chessBoard .square-b6').find('.piece-417db').length === 0 && $('#chessBoard .square-g3').find('.piece-417db').length === 0 && $('#chessBoard .square-d8').find('.piece-417db').length === 0 && $('#chessBoard .square-f8').find('.piece-417db').length === 0) ||
      (target === 'd2') ||
      (target === 'd8' && $('#chessBoard .square-b8').find('.piece-417db').length === 0 && $('#chessBoard .square-b6').find('.piece-417db').length === 0 && $('#chessBoard .square-d2').find('.piece-417db').length === 0 && $('#chessBoard .square-f8').find('.piece-417db').length === 0) ||
      (target === 'f2' && $('#chessBoard .square-d2').find('.piece-417db').length === 0 && $('#chessBoard .square-b6').find('.piece-417db').length === 0 && $('#chessBoard .square-a7').find('.piece-417db').length === 0 && $('#chessBoard .square-f8').find('.piece-417db').length === 0 && $('#chessBoard .square-g3').find('.piece-417db').length === 0) ||
      (target === 'f8' && $('#chessBoard .square-b8').find('.piece-417db').length === 0 && $('#chessBoard .square-d8').find('.piece-417db').length === 0 && $('#chessBoard .square-a3').find('.piece-417db').length === 0 && $('#chessBoard .square-f2').find('.piece-417db').length === 0) ||
      (target === 'g3' && $('#chessBoard .square-f2').find('.piece-417db').length === 0 && $('#chessBoard .square-a3').find('.piece-417db').length === 0 && $('#chessBoard .square-b8').find('.piece-417db').length === 0) ||
      (target === 'h7' && $('#chessBoard .square-b1').find('.piece-417db').length === 0 && $('#chessBoard .square-a7').find('.piece-417db').length === 0)
    ) {
      let msg = '';

      tryCount++;
      
      if (tryCount <= 1) {
        showMagnus({
          data: 'Oops...!!!<br/> Try again',
          position: 'left',
          styleClass: 'xs'
        })
        timeDelay = 4000
      } else {
        timeDelay = 1000
      }

      if(tryCount > 1) {
        msg = "Follow this path...<br/> b1-h7-a7-a3-f8-d8-b6-b8-g3-f2-d2.";
      } else {
        msg = "Here's a hint...<br/>the White Queen is the last piece you will capture.";
      }

      $('.square-55d63').addClass('no-action');

      setTimeout(function () {
        hideCapturedPieces();
        showMagnus({
          data: msg,
          position: 'left',
          styleClass: 'lg'
        })
        $('.square-55d63').removeClass('no-action');
        ChessBoard.board.position(initialBoardPosition);
        ChessBoard.game = new window.Chess(initialBoardPosition + BLACK_INITIAL_MOVE);
        return 'snapback';
      }, timeDelay)
    }
    ChessBoard.game = new window.Chess(boardFen + BLACK_INITIAL_MOVE);
  };

  const chessConfig = {
    config: {
      position: config.position,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onSnapEnd: onSnapEnd,
      draggable: true,
      sparePieces: true
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}

/**
* @name lesson7Assignment4
* @function
* @param {config}
* @description: chess board related task
*/
export function lesson7Assignment4(config) {
  let next = config.next,
    initialBoardPosition = config.position,
    tryCount = 0,
    timeDelay = 2000;

  let afterLoad = function () {
    prepareChessboard(config);
    tryCount = 0
  }

  let onDragStart = function (source, piece, position, orientation) {
    if (piece.search(BLACK_KING_SEARCH_KEY) !== -1 || piece.search(WHITE_PIECE_SEARCH_KEY) !== -1) {
      return false;
    }
  }

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    let move = ChessBoard.game.move({
      from: source,
      to: target,
    });

    if (move === null) {
      return 'snapback';
    } else {
      if (!move.captured) {
        let boardFen = ChessBoard.board.fen();
        ChessBoard.game = new window.Chess(boardFen + BLACK_INITIAL_MOVE);
        return 'snapback';
      } else {
        showCapturedPieces(piece, move)
      }
    }
  }

  var onSnapEnd = function (source, target, piece) {
    let boardFen = ChessBoard.board.fen();
    $("[data-piece=bK]")[0].style.display = "none";
    if ($('.chessboard-63f37').find('.piece-417db').length === 2) {
      loadNextConfiguration(3500, next, true)
    }
    else if (
      (target === 'a8' && $('#chessBoard .square-b8').find('.piece-417db').length === 0) ||
      (target === 'd7' && $('#chessBoard .square-d2').find('.piece-417db').length === 0 && $('#chessBoard .square-h7').find('.piece-417db').length === 0) ||
      (target === 'f2' && $('#chessBoard .square-d2').find('.piece-417db').length === 0 && $('#chessBoard .square-h4').find('.piece-417db').length === 0) ||
      (target === 'g5' && $('#chessBoard .square-h6').find('.piece-417db').length === 0 && $('#chessBoard .square-h4').find('.piece-417db').length === 0 && $('#chessBoard .square-d2').find('.piece-417db').length === 0) ||
      (target === 'h4' && $('#chessBoard .square-f2').find('.piece-417db').length === 0 && $('#chessBoard .square-g5').find('.piece-417db').length === 0 && $('#chessBoard .square-h6').find('.piece-417db').length === 0 && $('#chessBoard .square-h7').find('.piece-417db').length === 0) ||
      (target === 'h6' && $('#chessBoard .square-h7').find('.piece-417db').length === 0 && $('#chessBoard .square-g5').find('.piece-417db').length === 0 && $('#chessBoard .square-d2').find('.piece-417db').length === 0 && $('#chessBoard .square-h4').find('.piece-417db').length === 0)
    ) {
      let msg = '';

      tryCount++;
      
      if (tryCount <= 1) {
        showMagnus({
          data: 'Oops...!!!<br/> Try again',
          position: 'left',
          styleClass: 'xs'
        })
        timeDelay = 4000
      } else {
        timeDelay = 1000
      }

      if(tryCount > 1) {
        msg = "Follow this path...<br/> h6-g5-h4-f2-d2-d7-h7-b1-b8-a8.";
      } else {
        msg = "Here's a hint...<br/>the White King is the last piece you will capture.";
      }
      
      $('.square-55d63').addClass('no-action');

      setTimeout(function () {
        hideCapturedPieces();
        showMagnus({
          data: msg,
          position: 'left',
          styleClass: 'lg'
        })
        $('.square-55d63').removeClass('no-action');
        ChessBoard.board.position(initialBoardPosition);
        ChessBoard.game = new window.Chess(initialBoardPosition + BLACK_INITIAL_MOVE);
        return 'snapback';
      }, timeDelay)
    }
    ChessBoard.game = new window.Chess(boardFen + BLACK_INITIAL_MOVE);
  };

  const chessConfig = {
    config: {
      position: config.position,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onSnapEnd: onSnapEnd,
      draggable: true,
      sparePieces: true
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}


// WEBPACK FOOTER //
// ./src/lessons/lesson_7/assignments.js